
/* ============================== src/components/views/StaffView.jsx ============================== */
// src/components/views/StaffView.jsx
import { memo, useState } from "react";
import Staff from "../Staff";
import WorkloadView from "./WorkloadView";
import { Tabs } from "../Tabs";
import { useStaffDb } from "../../hooks/useDb";

/**
 * Раздел «Персонал» - контейнер с двумя вкладками:
 *   - «Сотрудники» - список сотрудников по КБ/отделам (Staff);
 *   - «Загрузка»   - дашборд загрузки сотрудников (WorkloadView).
 *
 * Вкладка «Загрузка» перенесена сюда из Cabinet. В Cabinet она была
 * видна всем ролям - здесь сохраняем то же поведение, никаких новых
 * проверок видимости не вводим (права не меняются).
 *
 * Состояние фильтров и сортировки каждой вкладки живёт внутри самой
 * вкладки (Staff / WorkloadView) и не поднимается в контейнер -
 * контейнер знает только «какая вкладка активна». Это соответствует
 * уже принятому в проекте паттерну (Cabinet, TaskModal, ProjectModal).
 *
 * Подвкладки не выносим в URL: раздел открывается по #/view/staff,
 * активная подвкладка - локальное состояние. URL-синхронизация была бы
 * усложнением без выгоды.
 */
const STAFF_TABS = [
  { id: "staff", label: "Сотрудники" },
  { id: "workload", label: "Загрузка персонала" },
];

function StaffView({
  store,
  ur,
  openRoles,
  openDepts,
  openVacation,
  openEmployeeTasks,
}) {
  const db = useStaffDb();
  const [tab, setTab] = useState("staff");

  return (
    <>
      <Tabs tabs={STAFF_TABS} active={tab} onChange={setTab} />

      {tab === "staff" && (
        <Staff
          store={store}
          db={db}
          ur={ur}
          openRoles={openRoles}
          openDepts={openDepts}
          openVacation={openVacation}
        />
      )}

      {tab === "workload" && (
        <WorkloadView
          ur={ur}
          store={store}
          openEmployeeTasks={openEmployeeTasks}
        />
      )}
    </>
  );
}

export default memo(StaffView);
